import {PlacementsSummary} from '../placementsManagementTool.types';

const CUSTOM_PARAM_BASE_TYPE = 40;
const CUSTOM_PARAM_TYPE_STEP = 10;

export default function formatPlacementsSummary(summary: PlacementsSummary): string {
  // Not in a campaign - return empty string
  if (!summary.isInCampaign) {
    return '';
  }

  // In a campaign but no placements - return message
  if (summary.totalCount === 0) {
    return 'Campaign currently has no placements';
  }

  const {
    totalCount,
    countByDsp,
    placementIdExamples,
    placementNameExamples,
    distinctEnvironments,
    customParams,
  } = summary;

  const lines: string[] = [];

  lines.push('Current Placements in Campaign:');
  lines.push(`Total Count: ${totalCount}`);

  // Per DSP
  if (Object.keys(countByDsp).length > 0) {
    lines.push('Per DSP:');

    Object.entries(countByDsp).forEach(([dspName, count]) => {
      lines.push(`  ${dspName} - ${count}`);
    });
  }

  // Placement ID examples
  if (placementIdExamples.length > 0) {
    lines.push(`Placement ID Examples: ${placementIdExamples.join(', ')}`);
  }

  // Placement name examples
  if (placementNameExamples.length > 0) {
    lines.push(`Placement Name Examples: ${placementNameExamples.join(', ')}`);
  }

  // Environments
  if (distinctEnvironments.length > 0) {
    lines.push(`Placement Environments: ${distinctEnvironments.join(', ')}`);
  }

  // Custom parameters
  Object.entries(customParams)
    .sort(([typeA], [typeB]) => Number(typeA) - Number(typeB))
    .forEach(([type, {examples, distinctCount}]) => {
      const typeNumber = Number(type);
      const displayIndex = Math.floor((typeNumber - CUSTOM_PARAM_BASE_TYPE) / CUSTOM_PARAM_TYPE_STEP);

      lines.push(
        `Custom Parameter ${displayIndex} Examples: ${examples.join(', ')} (${distinctCount} distinct values)`,
      );
    });

  return lines.join('\n');
}
